<template>
  <UserCreateEditForm :user-id="userId" />
</template>

<script setup lang="ts">
defineProps<{
  userId: string
}>()
</script>
